import React, { ChangeEvent } from 'react'
import Form from 'react-bootstrap/Form'

export default function NumberInput(props: {
  defaultValue?: number
  value?: number
  isInvalid?: boolean
  placeholder?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}): React.ReactElement {
  return (
    <Form.Control
      type='number'
      defaultValue={props.defaultValue}
      value={props.value}
      onChange={props.onChange}
      isInvalid={props.isInvalid}
      placeholder={props.placeholder}
      // Disables mouse wheel scrolling from updating value
      onFocus={(e): void =>
        e.target.addEventListener(
          "wheel",
          function (e) {
            e.preventDefault()
          },
          {passive: false}
        )
      }
    />
  )
}
